import React, { Component } from "react";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";

class ItemMaster extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      itemListing: [],
      isLoading: false,
      totalCount: 0,
      isEditing: false,
      isAllowForEditing: false,
      isGridView: true,
      tableStatus: "",
      itemDetails: {
        ItemName: "",
        Packing: "",
        UnitQuantity: null,
        ItemCategory: "",
        UOM: "",
        JobCharge: null,
        TestingCharge: null,
        ProdLoss: null,
        BasicRate: null,
        DiscountRate: null,
        MinimumQty: "",
        MaximumQty: "",
        NetRate: null,
        NonInventoryItem: false,
        TradePrice: null,
        MrpRs: null,
        HSNCode: "",
      },
      rmUOMList: [
        { label: "GM", value: 1 },
        { label: "KGS", value: 2 },
        { label: "IU", value: 3 },
        { label: "LTR", value: 4 },
        { label: "MCG", value: 5 },
        { label: "MG", value: 6 },
        { label: "ML", value: 7 },
        { label: "NOS", value: 8 },
      ],
      hsnCodeList: [],
      itemCategoryList: [],
      searchByItemName: "",
      validationRules: {
        ItemName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "item name"
            ),
          },
        ],
        Packing: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "packings"
            ),
          },
        ],
        UnitQuantity: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "unit quantity"
            ),
          },
        ],
        ItemCategory: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "category"
            ),
          },
        ],
        JobCharge: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "job charge"
            ),
          },
        ],
        TestingCharge: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "testing charge"
            ),
          },
        ],
        ProdLoss: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "production loss"
            ),
          },
        ],
        BasicRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "basic rate"
            ),
          },
        ],
        DiscountRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "discount rate"
            ),
          },
        ],
        MinimumQty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "minimum qty"
            ),
          },
        ],
        MaximumQty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "maximum qty"
            ),
          },
        ],
        NetRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "net rate"
            ),
          },
        ],
        MrpRs: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "mrp"
            ),
          },
        ],
        HSNCode: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "hsn code"
            ),
          },
        ],
        NetRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "net rate"
            ),
          },
        ],
        UOM: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "UOM"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllItems(this.state.searchByItemName);
  }

  getAllItems = (ItemName) => {
    this.setState({ tableStatus: "Loading..." })

    this.itemMasterServices.getAllItems(ItemName).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let totalCount = response.responseData.length;
        if (totalCount === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          {
            itemListing: response.responseData,
            totalCount: totalCount,
          },
          () => {
            this.getAllItemCategory();
          }
        );
      } else {
        this.setState({ tableStatus: "" })
        this.getAllItemCategory();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getItemById = (id) => {
    this.itemMasterServices.getItemById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        details.UnitQuantity = details.UnitQuantity.toFixed(3);
        details.JobCharge = details.JobCharge.toFixed(3);
        details.TestingCharge = details.TestingCharge.toFixed(3);
        details.ProdLoss = details.ProdLoss.toFixed(3);
        details.BasicRate = details.BasicRate.toFixed(3);
        details.DiscountRate = details.DiscountRate.toFixed(3);
        details.NetRate = details.NetRate.toFixed(3);
        details.TradePrice = details.TradePrice.toFixed(3);
        details.MrpRs = details.MrpRs.toFixed(3);
        details.MinimumQty = details.MinimumQty.toFixed(2);
        details.MaximumQty = details.MaximumQty.toFixed(2);
        this.setState({ itemDetails: details, _id: details._id }, () => {
          this.setState({ isEditing: true, isGridView: false, isAllowForEditing: true });
        });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllItemCategory = () => {
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ itemCategoryList: response.responseData }, () => {
          this.getAllHSNCode();
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllHSNCode();
      }
    });
  };

  getAllHSNCode = () => {
    this.commonServices.getAllHSNCode().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ hsnCodeList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.itemDetails;
    details[name] = value.toUpperCase();
    this.setState({ itemDetails: details });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;

    let details = this.state.itemDetails;
    details[name] = selectedYear;
    this.setState({ itemDetails: details });

  };

  handleCheckbox = (e, name) => {
    let details = this.state.itemDetails;
    details[name] = !details.NonInventoryItem;
    this.setState({ itemDetails: details });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.itemDetails;
    details._id = "";
    details.ItemName = "";
    details.Packing = "";
    details.UnitQuantity = "";
    details.ItemCategory = "";
    details.UOM = "";
    details.JobCharge = "";
    details.TestingCharge = "";
    details.ProdLoss = "";
    details.BasicRate = "";
    details.DiscountRate = "";
    details.MinimumQty = "";
    details.MaximumQty = "";
    details.NetRate = "";
    details.NonInventoryItem = false;
    details.TradePrice = "";
    details.MrpRs = "";
    details.HSNCode = "";
    this.setState(
      { itemDetails: details, validState: validState, searchByItemName: "", tableStatus: "", isEditing: false, isAllowForEditing: false },
      () => {
        this.getAllItems(this.state.searchByItemName);
      }
    );
  };

  addEditItems = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.itemDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditItems(request).then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message);
            this.resetForm();
            this.getAllItems(this.state.searchByItemName);
            this.setState({ isGridView: true, isLoading: false });
          } else if (response.statusCode === 409) {
            this.SwalServices.Warning(response.Message);
            this.setState({ isGridView: true, isLoading: false });
          } else {
            this.setState({ isLoading: false })
            this.SwalServices.Error(response.Message);
          }
        });
      });
    }
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false, isAllowForEditing: false });
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllItems(this.state.searchByItemName);
    });
  };

  deleteItemById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this item?`
    ).then((response) => {
      if (response === true) {
        this.itemMasterServices.deleteItemById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.setState({ searchByItemName: "" }, () => {
              this.getAllItems(this.state.searchByItemName);
            });
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.itemDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.itemDetails
    details[drpIdentity] = selected.label
    this.setState({ itemDetails: details });
  };

  copyItem = () => {
    let details = this.state.itemDetails
    details.ItemName = ''
    this.setState({ itemDetails: details, _id: '', isEditing: false })
  }

  render() {
    return (
      <div className="item-add">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-[10px]">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Item name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autocomplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <p className=" mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
            <div className="itemList-table">
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "28%" }}>Item Name </td>

                      <td style={{ width: "8%" }}>Category </td>
                      <td style={{ width: "8%" }}>Basic Rate</td>
                      <td style={{ width: "10%" }}>Discount[%]</td>
                      <td style={{ width: "8%" }}>Min Qty.</td>
                      <td style={{ width: "8%" }}>Max Qty.</td>
                      <td style={{ width: "9%" }}>M.R.P. Rs.</td>
                      <td style={{ width: "9%" }}>HSN Code</td>
                      <td style={{ width: "12%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>

                  {/* {this.state.isLoding === true ? <tbody>
                    <tr  >
                      <td colSpan={9} style={{ textAlign: "center", fontSize: "16px" }}>
                        Loading...
                      </td>
                    </tr>
                  </tbody> : null} */}

                  <tbody>
                    {this.state.itemListing &&
                      this.state.itemListing.length > 0 ? (
                      this.state.itemListing.map((item, key) => (

                        <tr key={key}>
                          <td >{item.ItemName} </td>

                          <td>{item.ItemCategory} </td>
                          <td>{item.BasicRate.toFixed(2)}</td>
                          <td>{item.DiscountRate.toFixed(2)}%</td>
                          <td>{item.MinimumQty}</td>
                          <td>{item.MaximumQty}</td>
                          <td>{item.MrpRs.toFixed(2)}</td>
                          <td>{item.HSNCode}</td>
                          <td className="!text-center" >
                            <button
                              className="search-btn"
                              onClick={() => this.getItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() => this.deleteItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>

                      ))
                    ) : this.state.itemListing &&
                      this.state.itemListing.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={9} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.itemListing &&
                      this.state.itemListing.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                  </tbody>

                </table>
              </div>
            </div>
          </>
        ) : null
        }
        {
          this.state.isGridView === false ? (
            <div className="item-listing">
              <div className="item-form">
                <div className="form-table">
                  <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3">
                    <div className="input-grp">
                      <label>Item Name</label>
                      <input
                        className={`inputFocus ${this.state.validState?.error?.ItemName ? "errorInput" : ""}`}
                        type="text"
                        id="ItemName"
                        name="ItemName"
                        autocomplete="off"
                        value={this.state.itemDetails.ItemName}
                        onChange={(event) => this.handleChange(event, "ItemName")}
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.ItemName}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>Packing</label>
                      <input
                        className={`inputFocus ${this.state.validState?.error?.Packing ? "errorInput" : ""}`}
                        type="text"
                        id="Packing"
                        name="Packing"
                        autocomplete="off"
                        value={this.state.itemDetails.Packing}
                        onChange={(event) => this.handleChange(event, "Packing")}
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.Packing}
                      /> */}
                    </div>
                  </div>
                  <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3">
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Category</label>
                        <select
                          className={` ${this.state.validState?.error?.ItemCategory ? "errorInput" : ""}`}
                          name="ItemCategory"
                          value={this.state.itemDetails.ItemCategory}
                          onChange={(e) =>
                            this.handleDropdownChange(e, "ItemCategory")
                          }
                        >
                          <option>Select</option>
                          {this.state.itemCategoryList.map((x, key) => (
                            <option key={key} value={x.categoryName}>
                              {x.categoryName}
                            </option>
                          ))}
                        </select>
                        {/* <ValidationText
                          error={this.state.validState.error.ItemCategory}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>Unit Qty.</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.UnitQuantity ? "errorInput" : ""}`}
                          type="number"
                          id="UnitQuantity"
                          name="UnitQuantity"
                          autocomplete="off"
                          value={this.state.itemDetails.UnitQuantity}
                          onChange={(event) =>
                            this.handleChange(event, "UnitQuantity")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.UnitQuantity}
                        /> */}
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>U-O-M</label>
                        {/* <input
                          className={`inputFocus ${this.state.validState?.error?.UOM ? "errorInput" : ""}`}
                          type="text"
                          id="UOM"
                          name="UOM"
                          autocomplete="off"
                          value={this.state.itemDetails.UOM}
                          onChange={(event) => this.handleChange(event, "UOM")}
                        /> */}
                        <MultiSelectDropdown
                          drpIdentity="UOM"
                          options={this.state.rmUOMList}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) => this.setFilterParameters(selected, "UOM")}
                          className={` ${this.state.validState?.error?.UOM ? "errorInput" : ""}`}
                          allowSelectAll={false}
                          value={this.state.rmUOMList.filter(
                            (party) => party.label === this.state.itemDetails.UOM
                          )}
                        />
                        {/* <ValidationText error={this.state.validState.error.UOM} /> */}
                      </div>
                      <div className="input-grp">
                        <label>Job Charge</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.ItemName ? "errorInput" : ""}`}
                          type="number"
                          id="JobCharge"
                          name="JobCharge"
                          autocomplete="off"
                          value={this.state.itemDetails.JobCharge}
                          onChange={(event) =>
                            this.handleChange(event, "JobCharge")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.JobCharge}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3">
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Testing Charge</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.TestingCharge ? "errorInput" : ""}`}
                          type="number"
                          id="TestingCharge"
                          name="TestingCharge"
                          autocomplete="off"
                          value={this.state.itemDetails.TestingCharge}
                          onChange={(event) =>
                            this.handleChange(event, "TestingCharge")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.TestingCharge}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>prod. Loss[%]</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.ProdLoss ? "errorInput" : ""}`}
                          type="number"
                          id="ProdLoss"
                          name="ProdLoss"
                          autocomplete="off"
                          value={this.state.itemDetails.ProdLoss}
                          onChange={(event) => this.handleChange(event, "ProdLoss")}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.ProdLoss}
                        /> */}
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Basic Rate</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.BasicRate ? "errorInput" : ""}`}
                          type="number"
                          id="BasicRate"
                          name="BasicRate"
                          autocomplete="off"
                          value={this.state.itemDetails.BasicRate}
                          onChange={(event) =>
                            this.handleChange(event, "BasicRate")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.BasicRate}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>Discount[%]</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.DiscountRate ? "errorInput" : ""}`}
                          type="number"
                          id="DiscountRate"
                          name="DiscountRate"
                          autocomplete="off"
                          value={this.state.itemDetails.DiscountRate}
                          onChange={(event) =>
                            this.handleChange(event, "DiscountRate")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.DiscountRate}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3">
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Minimum Qty.</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.MinimumQty ? "errorInput" : ""}`}
                          type="number"
                          id="MinimumQty"
                          name="MinimumQty"
                          autocomplete="off"
                          value={this.state.itemDetails.MinimumQty}
                          onChange={(event) =>
                            this.handleChange(event, "MinimumQty")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.MinimumQty}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>Maximum Qty.</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.MaximumQty ? "errorInput" : ""}`}
                          type="number"
                          id="MaximumQty"
                          name="MaximumQty"
                          autocomplete="off"
                          value={this.state.itemDetails.MaximumQty}
                          onChange={(event) =>
                            this.handleChange(event, "MaximumQty")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.MaximumQty}
                        /> */}
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Net Rate</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.NetRate ? "errorInput" : ""}`}
                          type="number"
                          id="NetRate"
                          name="NetRate"
                          autocomplete="off"
                          value={this.state.itemDetails.NetRate}
                          onChange={(event) => this.handleChange(event, "NetRate")}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.NetRate}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>Trade Price</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.TradePrice ? "errorInput" : ""}`}
                          type="number"
                          name="TradePrice"
                          id="TradePrice"
                          autocomplete="off"
                          value={this.state.itemDetails.TradePrice}
                          onChange={(event) =>
                            this.handleChange(event, "TradePrice")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.TradePrice}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3.5">
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>M.R.P. Rs.</label>
                        <input
                          className={`inputFocus ${this.state.validState?.error?.MrpRs ? "errorInput" : ""}`}
                          type="number"
                          name="MrpRs"
                          id="MrpRs"
                          autocomplete="off"
                          value={this.state.itemDetails.MrpRs}
                          onChange={(event) => this.handleChange(event, "MrpRs")}
                        />
                        {/* <ValidationText error={this.state.validState.error.MrpRs} /> */}
                      </div>
                      <div className="input-grp">
                        <label>HSN Code</label>
                        <select
                          className={` ${this.state.validState?.error?.HSNCode ? "errorInput" : ""}`}
                          name="HSNCode"
                          value={this.state.itemDetails.HSNCode}
                          onChange={(e) => this.handleDropdownChange(e, "HSNCode")}
                        >
                          <option>Select</option>
                          {this.state.hsnCodeList &&
                            this.state.hsnCodeList.length > 0 &&
                            this.state.hsnCodeList.map((code, key) => (
                              <option key={key} value={code.HSNCode}>
                                {code.HSNCode}
                              </option>
                            ))}
                        </select>
                        {/* <ValidationText error={this.state.validState.error.HSNCode} /> */}
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">

                      <div className="input-grp pt-[25px] flex items-center">
                        <input
                          className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                          type="checkbox"
                          name="NonInventoryItem"
                          id="NonInventoryItem"
                          autocomplete="off"
                          value={this.state.itemDetails.NonInventoryItem}
                          checked={this.state.itemDetails.NonInventoryItem}
                          onChange={(event) =>
                            this.handleCheckbox(event, "NonInventoryItem")
                          }
                        />
                        <label className="!mb-0">Non-Inventory Item</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-grp">
                  {this.state.isEditing === true ? (
                    <button
                      className="add-btn"
                      disabled={this.state.isLoading}
                      onClick={() => this.addEditItems()}
                    >
                      {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                    </button>
                  ) : (
                    <button
                      className="add-btn"
                      disabled={this.state.isLoading}
                      onClick={() => this.addEditItems()}
                    >
                      {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                    </button>
                  )}

                  <button
                    disabled={this.state.isLoading}
                    className="cancel-btn !ml-[0]"
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                  {this.state.isAllowForEditing ?
                    <button
                      disabled={this.state.isLoading}
                      className="search-btn !ml-[0]"
                      onClick={() => this.copyItem()}
                    >
                      Copy
                    </button>
                    : null}
                </div>
              </div>
            </div>
          ) : null
        }
      </div >
    );
  }
}

export default ItemMaster;
